/**
 * Ghana's 16 regions and their districts (MMDAs), for the sign-up drop-downs.
 * Source: geoBoundaries gbOpen GHA ADM2 (USAID Ghana HPNO / Ghana Statistical
 * Service, CC BY 4.0) with each district placed in the region it overlaps most
 * (geoBoundaries GHA ADM1, OpenStreetMap). 260 districts; a district created
 * later can be picked as "Other / not listed". Boundaries for "Use my location"
 * are in public/data/gh-districts.json.
 */
export const GHANA_REGIONS = [
  { name: "Ahafo", districts: [
    "Asunafo North Municipal",
    "Asunafo South",
    "Asutifi North",
    "Asutifi South",
    "Tano North Municipal",
    "Tano South Municipal",
  ] },
  { name: "Ashanti", districts: [
    "Adansi Akrofuom",
    "Adansi Asokwa",
    "Adansi North",
    "Adansi South",
    "Afigya Kwabre North",
    "Afigya Kwabre South",
    "Ahafo Ano North",
    "Ahafo Ano South East",
    "Ahafo Ano South West",
    "Amansie Central",
    "Amansie South",
    "Amansie West",
    "Asante Akim Central Municipal",
    "Asante Akim North",
    "Asante Akim South",
    "Asokore Mampong Municipal",
    "Asokwa  Municipal",
    "Atwima Kwanwoma",
    "Atwima Mponua",
    "Atwima Nwabiagya North",
    "Atwima Nwabiagya South",
    "Bekwai Municipal",
    "Bosome Freho",
    "Bosomtwe",
    "Ejisu Municipal",
    "Ejura-Sekyedumase",
    "Juaben Municipal",
    "Kumasi Metropolitan",
    "Kwabre East",
    "Kwadaso Municipal",
    "Mampong Municipal",
    "Obuasi East",
    "Obuasi Municipal",
    "Offinso Municipal",
    "Offinso North",
    "Oforikrom Municipal",
    "Old Tafo Municipal",
    "Sekyere Afram Plains North",
    "Sekyere Central",
    "Sekyere East",
    "Sekyere Kumawu",
    "Sekyere South",
    "Suame Municipal",
  ] },
  { name: "Bono", districts: [
    "Banda",
    "Berekum East Municipal",
    "Berekum West",
    "Dormaa East",
    "Dormaa Municipal",
    "Dormaa West",
    "Jaman North",
    "Jaman South Municipal",
    "Sunyani Municipal",
    "Sunyani West",
    "Tain",
    "Wenchi Municipal",
  ] },
  { name: "Bono East", districts: [
    "Atebubu Amantin",
    "Kintampo North Municipal",
    "Kintampo South",
    "Nkoranza North",
    "Nkoranza South",
    "Pru East",
    "Pru West",
    "Sene East",
    "Sene West",
    "Techiman Municipal",
    "Techiman North",
  ] },
  { name: "Central", districts: [
    "Abura-Asebu-Kwamankese",
    "Agona East",
    "Agona West Municipal",
    "Ajumako-Enyan-Essiam",
    "Asikuma-Odoben-Brakwa",
    "Assin Fosu",
    "Assin North",
    "Assin South",
    "Awutu Senya",
    "Awutu Senya East",
    "Cape Coast Metropolitan",
    "Effutu Municipal",
    "Ekumfi",
    "Gomoa Central",
    "Gomoa East",
    "Gomoa West",
    "Komenda-Edina-Eguafo-Abirem Municipal",
    "Mfantseman Municipal",
    "Twifo Atti-Morkwa",
    "Twifo Hemang Lower Denkyira",
    "Upper Denkyira East Municipal",
    "Upper Denkyira West",
  ] },
  { name: "Eastern", districts: [
    "Abuakwa North",
    "Abuakwa South",
    "Achiase",
    "Akwapem North",
    "Akwapem South",
    "Akyem Mansa",
    "Asene Akroso Manso",
    "Asuogyaman",
    "Atiwa East",
    "Atiwa West",
    "Ayensuano",
    "Birim Central Municipal",
    "Birim North",
    "Birim South",
    "Denkyembour",
    "Fanteakwa North",
    "Fanteakwa South",
    "Kwaebibirem",
    "Kwahu Afram Plains North",
    "Kwahu Afram Plains South",
    "Kwahu East",
    "Kwahu South",
    "Kwahu West",
    "Lower Manya",
    "New Juaben North Municipal",
    "New Juaben South Municipal",
    "Nsawam Adoagyiri",
    "Okere",
    "Suhum Municipal",
    "Upper Manya",
    "Upper West Akim",
    "West Akim",
    "Yilo Krobo",
  ] },
  { name: "Greater Accra", districts: [
    "Ablekuma Central Municipal",
    "Ablekuma North Municipal",
    "Ablekuma West Municipal",
    "Accra Metropolis",
    "Ada East",
    "Ada West",
    "Adenta Municipal",
    "Ashaiman Municipal",
    "Ayawaso Central Municipal",
    "Ayawaso East Municipal",
    "Ayawaso North Municipal",
    "Ayawaso West",
    "Ga Central Municipal",
    "Ga East",
    "Ga North Municipal",
    "Ga South Municipal",
    "Ga West Municipal",
    "Korle Klottey Municipal",
    "Kpone Katamanso",
    "Krowor Municipal",
    "La Dade-Kotopon",
    "La-Nkwantanang-Madina",
    "Ledzokuku Municipal",
    "Ningo/prampram",
    "Okaikwei North Municipal",
    "Shai Osudoku",
    "Tema Metropolitan",
    "Tema West Municipal",
    "Weija Gbawe Municipal",
  ] },
  { name: "North East", districts: [
    "Bunkpurugu Nakpanduri",
    "Chereponi",
    "East Mamprusi",
    "Mamprugu Moagduri",
    "West Mamprusi Municipal",
    "Yunyoo-Nasuan",
  ] },
  { name: "Northern", districts: [
    "Gushegu",
    "Karaga",
    "Kpandai",
    "Kumbungu",
    "Mion",
    "Nanton",
    "Nanumba North",
    "Nanumba South",
    "Saboba",
    "Sagnerigu",
    "Savelugu",
    "Tamale Metropolitan",
    "Tatale Sanguli",
    "Tolon",
    "Yendi Municipal",
    "Zabzugu",
  ] },
  { name: "Oti", districts: [
    "Biakoye",
    "Jasikan",
    "Kadjebi",
    "Krachi East Municipal",
    "Krachi Nchumuru",
    "Krachi West",
    "Nkwanta North",
    "Nkwanta South Municipal",
  ] },
  { name: "Savannah", districts: [
    "Bole",
    "Central Gonja",
    "East Gonja Municipal",
    "North East Gonja",
    "North Gonja",
    "Sawla-Tuna-Kalba",
    "West Gonja",
  ] },
  { name: "Upper East", districts: [
    "Bawku Municipal",
    "Bawku West",
    "Binduri",
    "Bolga  East",
    "Bolgatanga Municipal",
    "Bongo",
    "Builsa North",
    "Builsa South",
    "Garu",
    "Kasena Nankana East",
    "Kasena Nankana West",
    "Nabdam",
    "Pusiga",
    "Talensi",
    "Tempane",
  ] },
  { name: "Upper West", districts: [
    "Daffiama Bussie Issa",
    "Jirapa",
    "Lambussie-Karni",
    "Lawra",
    "Nadowli-Kaleo",
    "Nandom",
    "Sissala East",
    "Sissala West",
    "Wa East",
    "Wa Municipal",
    "Wa West",
  ] },
  { name: "Volta", districts: [
    "Adaklu",
    "Afadzato South",
    "Agotime Ziope",
    "Akatsi North",
    "Akatsi South",
    "Anloga",
    "Central Tongu",
    "Ho Municipal",
    "Ho West",
    "Hohoe Municipal",
    "Keta Municipal",
    "Ketu North",
    "Ketu South",
    "Kpando Municipal",
    "North Dayi",
    "North Tongu",
    "South Dayi",
    "South Tongu",
  ] },
  { name: "Western", districts: [
    "Ahanta West Municipal",
    "Effia Kwesimintsim Municipal",
    "Ellembelle",
    "Jomoro",
    "Mpohor",
    "Nzema East",
    "Prestea/huni Valley",
    "Sekondi Takoradi Metropolis",
    "Shama",
    "Tarkwa Nsuaem",
    "Wassa Amenfi Central",
    "Wassa Amenfi East",
    "Wassa Amenfi West",
    "Wassa East",
  ] },
  { name: "Western North", districts: [
    "Aowin",
    "Bia East",
    "Bia West",
    "Bibiani-Anhwiaso-Bekwai Municipal",
    "Bodi",
    "Juaboso",
    "Sefwi Akontombra",
    "Sefwi-Wiawso",
    "Suaman",
  ] },
];

export const OTHER_DISTRICT = 'Other / not listed';

export const districtsOf = (region) => GHANA_REGIONS.find(r => r.name === region)?.districts || [];

export const isKnownDistrict = (region, district) => district === OTHER_DISTRICT || districtsOf(region).includes(district);
